import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ChangePasswordGuard implements CanActivate {
  constructor(private store: Store<fromRoot.State>,
              private router: Router) {}

  canActivate() {
      return this.store.select(fromRoot.getAuthMustChangePassword)
        .map(li => {
          if (li) {
            this.router.navigate(['changepassword']);
          }
          return !li;
        });
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/guards/change-password.ts